import React, { FC, ComponentProps } from "react";
import { cls } from "@wss/cls";

const ResultTitle: FC<ComponentProps<"p">> = ({
  className,
  children,
  ...rest
}) => (
  <p
    className={cls(
      "font-semibold text-sm leading-none [text-shadow:none] mb-2.5 pb-2 text-gray-800 border-0 border-b border-gray-300 border-solid",
      className,
    )}
    {...rest}
  >
    {children}
  </p>
);

export default ResultTitle;
